import { Area } from './infrastructure'
import { Lease } from './lease'
import { Attachment, Message } from './message'
import { IdentifiableNamedObject, IdentifiableObject } from './types'
import { User } from './user'

export interface _ServiceRequest extends IdentifiableObject {
    lease: Lease
    status: ServiceRequestStatus
    description: string
    category: ServiceRequestCategory
    has_pet: boolean
    start_date: string
    message: Message
    entry_note?: string
    invalid_dates?: string
    area?: Area
    action_item?: ActionItem
}

export enum ServiceRequestStatus {
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    ASSIGNED = 'ASSIGNED',
    IN_PROGRESS = 'IN_PROGRESS',
    PAUSE = 'PAUSE',
    COMPLETE = 'COMPLETE',
}

export interface Service {
    id: number
    name: string
    color: string
    order: number
    checked?: boolean
}

export interface ServiceRequestCategory extends IdentifiableObject {
    name: string
    services: Service[]
}

export interface ActionItem {
    id: number
    status: ActionItemStatus
    title: string
    folder_location?: FolderLocation
    unit_location?: IdentifiableNamedObject
    service?: IdentifiableNamedObject
    area?: Area
    priority?: boolean
    assigned_to: string
    assigned_to_id: number
    assigned_by: User
    unread_count: number
    start_date?: string
    inventory_inspection: number | null
    channel: number
    message_count: number
    service_request: number | null
    attachments: Attachment[]
}

export enum ActionItemStatus {
    STAGED = 'STAGED',
    REJECTED = 'REJECTED',
    ASSIGNED = 'ASSIGNED',
    IN_PROGRESS = 'IN_PROGRESS',
    PAUSE = 'PAUSE',
    COMPLETE = 'COMPLETE',
}

export type AssignmentWhoType = 'WHO_COMPANY' | 'WHO_USER'

interface FolderLocation extends IdentifiableNamedObject {
    path: string
}

export enum WorkorderStatus {
    ASSIGNED = 'ASSIGNED',
    IN_PROGRESS = 'IN_PROGRESS',
    PAUSE = 'PAUSE',
    COMPLETE = 'COMPLETE',
    GO_BACK = 'GO_BACK',
    PRE_APPROVED = 'PRE_APPROVED',
    APPROVED = 'APPROVED',
    INVOICED = 'INVOICED',
}

export const activeStatuses = [
    WorkorderStatus.ASSIGNED,
    WorkorderStatus.GO_BACK,
    WorkorderStatus.IN_PROGRESS,
    WorkorderStatus.PAUSE,
]

export interface ServiceRequestWorkorder extends IdentifiableObject {
    start_date: number
    end_date: number
    status: WorkorderStatus
    title: string
    assigned_to: {
        id: number
        name: string
    } | null
}

export interface ServiceRequest extends IdentifiableObject {
    issue_title: string
    description: string
    priority: 'low' | 'medium' | 'high' | 'emergency'
    status: 'submitted' | 'acknowledged' | 'in_progress' | 'completed'
    category: string
    estimatedCompletion?: string
    progress?: number
    image: string | null
    location_description: string
    preferred_visit_time: string
    channel_id: number | null
    message_count: number
    unread_count: number
    workorder: ServiceRequestWorkorder | null
    lease_id: number
    tenant: string
    folder_name: string
    path: string
    unit_name: string
    created_date: string
}

export interface MaintenanceRequestForm {
    title: string
    description: string
    priority: 'low' | 'medium' | 'high' | 'emergency'
    category: string
    location: string
    preferredTime: string
    image: File | null
}
